export enum SOCKET_EVENT {
    updated = 'booking:updated',
  }
  